<template>
    <div class="game-container">
        <div class="game-header">
            <h1 class="text-2xl md:text-3xl font-bold mb-2">单词拼写挑战</h1>
            <p class="text-gray-600">拖动字母到下方组成正确单词</p>
        </div>
        <div>
            <el-row>
                <el-col :span="6">
                    <div class="word-title">得分</div>
                    <div class="word-title"><span class="game-info-span">{{ getScore() }}</span></div>
                </el-col>
                <el-col :span="12">
                    <div class="word-title">难易度<span class="game-info-span"></span></div>
                    <div class="word-title"><el-rate v-model="currentGame.difficulty" disabled :max="3"
                            text-color="#ff9900">
                        </el-rate></div>
                </el-col>
                <el-col :span="6">
                    <div class="word-title">剩余时间</div>
                    <div class="word-title"><span class="game-info-span">{{ currentGame.time }}</span></div>
                </el-col>
            </el-row>
        </div>
        <!-- 提示信息 -->
        <div class="hint-box mb-6 p-3 bg-blue-50 rounded-lg">
            <p><span>汉语释义： "{{ currentGame.cnWord }}"</span><i @click="playAudio()"
                    :class="['word-play', iconPlay]"></i></p>
        </div>
        <!-- 打乱的字母区域 -->
        <div class="letters-container mb-8 p-4 bg-gray-50 rounded-lg min-h-[100px]">
            <div v-for="(letter, index) in shuffledLetters" :key="index" class="letter-item"
                :class="{ 'dragging': draggedLetter === letter }" draggable @dragstart="handleDragStart(letter)"
                @dragend="handleDragEnd" @touchstart="handleTouchStart(letter, $event)"
                @touchmove="handleTouchMove($event)" @touchend="handleTouchEnd">
                {{ letter }}
            </div>
        </div>
        <!-- 输入框区域 -->
        <div class="input-container mb-6">
            <div v-for="(slot, index) in inputSlots" :key="index" class="input-slot" :class="{
                'filled': slot,
                'highlighted': highlightedIndex === index,
                'correct': resultChecked && slot === targetWord[index],
                'incorrect': resultChecked && slot !== targetWord[index] && slot
            }" @dragover.prevent @dragenter.prevent="handleDragEnter(index)" @dragleave="handleDragLeave(index)"
                @drop="handleDrop(index)" @touchstart="handleSlotTouchStart(index, $event)">
                {{ slot }}
            </div>
        </div>
        <!-- <el-row>
            <div class="sound-uppercase">
                <el-switch v-model="showUppercase" @change="upperChange" active-text="A" inactive-text="a">
                </el-switch>
            </div>
        </el-row> -->
        <!-- 控制按钮 -->
        <div class="controls">
            <el-button v-if="!resultChecked" type="success" @click="checkResult" icon="el-icon-document-checked"
                :disabled="!inputSlots.every(slot => slot)" size="middle">检查答案</el-button>
            <el-button v-if="currentGame.time === 0 && limitCount > 0 || limitCount > 0 && allowNext" type="primary"
                @click="nextGame()" size="small">下一局</el-button>
            <el-button v-if="limitCount === 0" type="primary" @click="reloadGame()" size="small">再开一局</el-button>
            <el-button v-if="limitCount > 0 && allowNext && !isCorrect" type="primary" icon="el-icon-refresh"
                @click="resetAnswer" size="middle">重填</el-button>
        </div>

        <!-- 结果提示 -->
        <div v-if="resultChecked" class="result-message" :class="isCorrect ? 'success' : 'error'">
            {{ isCorrect ? '恭喜你，答案正确！' : '再试一次，答案不正确哦！' }}
        </div>

        <!-- 触摸模式下的字母跟随器 -->
        <div v-if="isTouchDragging && draggedLetter" class="touch-follower" :style="{
            left: touchX + 'px',
            top: touchY + 'px'
        }">
            {{ draggedLetter }}
        </div>
    </div>
</template>

<script>
import api from '@/utils/api'
import { Howl } from 'howler'
export default {
    name: 'LetterDragGame',
    props: {
        games: {
            type: Array,
            default: () => ([])
        }
    },
    data () {
        return {
            // 目标单词
            targetWord: 'MOBILE',
            // 打乱的字母数组
            shuffledLetters: [],
            // 输入框数组
            inputSlots: [],
            // 当前拖动的字母
            draggedLetter: null,
            // 当前高亮的输入框索引
            highlightedIndex: -1,
            // 是否已检查结果
            resultChecked: false,
            // 结果是否正确
            isCorrect: false,
            // 触摸相关属性
            isTouchDragging: false,
            showUppercase: true,
            currectCount: 0,
            touchX: 0,
            touchY: 0,
            touchStartX: 0,
            touchStartY: 0,
            touchThreshold: 10, // 触摸移动阈值，防止误触
            selectedSlotIndex: -1, // 触摸选中的槽位
            iconPlay: 'el-icon-video-play',
            myAudio: null,
            currentGame: { word: 'MOBILE', audioUrlId: 1 },
            successAudio: null,
            failAudio: null,
            limitCount: 10, // 限制游戏次数
            allowNext: false
        }
    },
    created () {
        this.loadSound()
        // 初始化由 watcher 负责处理 props.games 的异步变化
        this.targetWord = this.games.length > 0 ? this.games[0].word.toUpperCase() : 'MOBILE'
        this.currentGame = this.games.length > 0 ? Object.assign({}, this.games[0]) : { word: 'MOBILE', audioUrlId: 1 }
    },
    mounted () {
        this.initGame()
        this.showUppercase = true
        // 阻止页面在触摸拖动时滚动
        document.addEventListener('touchmove', (e) => {
            if (this.isTouchDragging) {
                e.preventDefault()
            }
        }, { passive: false })
    },
    methods: {
        upperChange () {
            // 切换大小写时不需要额外处理，因为显示逻辑已经绑定到 showUppercase
            console.log('upperChange called', this.showUppercase)
            // this.showUppercase = !this.showUppercase
        },
        // 初始化游戏
        initGame () {
            // 重置游戏状态
            this.resultChecked = false
            this.isCorrect = false
            this.highlightedIndex = -1
            this.draggedLetter = null
            this.isTouchDragging = false
            this.selectedSlotIndex = -1
            this.allowNext = false
            this.currectCount = 0

            // 初始化输入框
            this.inputSlots = Array(this.targetWord.length).fill('')

            // 生成打乱的字母
            this.shuffledLetters = this.shuffleArray(Array.from(this.targetWord))
            this.timer()
        },
        nextGame () {
            this.limitCount--
            if (this.limitCount <= 0) {
                this.$emit('save-answer', this.getScore())// 通知父组件重新加载数据// 自动保存答案
                return
            }
            if (this.games.length > 0 && this.currentGame.index < this.games.length) {
                var index = this.currentGame.index + 1
                this.currentGame = Object.assign({}, this.games[index])
                this.targetWord = this.currentGame.word.toUpperCase()
            }
            this.initGame()

            console.log('nextGame', this.currentGame)
        },
        reloadGame () {
            this.$confirm('已经完成，继续重做?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
                center: true
            }).then(() => {
                this.$emit('load-game') // 通知父组件重新加载数据
            })
        },
        timer () {
            if (this.currentGame.time > 0) {
                this.currentGame.time--
                // 使用箭头函数保持 this 指向组件实例
                setTimeout(() => this.timer(), 1000)
            }
        },
        getScore () {
            return this.currectCount * 10
        },
        resetAnswer () {
            // 重置输入框和字母
            this.inputSlots = Array(this.targetWord.length).fill('')
            this.shuffledLetters = this.shuffleArray(Array.from(this.targetWord))
            this.resultChecked = false
            this.isCorrect = false
            this.highlightedIndex = -1
            this.draggedLetter = null
            this.isTouchDragging = false
            this.selectedSlotIndex = -1
        },
        loadSound () {
            this.$axios.get(api.getSuccessMp3)
                .then(res => {
                    this.successAudio = res.data.result.base64Data
                })
            this.$axios.get(api.getFailedMp3)
                .then(res => {
                    this.failAudio = res.data.result.base64Data
                })
        },
        playAudio () {
            this.iconPlay = 'el-icon-video-pause'
            if (this.myAudio) {
                this.myAudio.unload()// 释放音频资源
                this.myAudio = null
            }
            var wordId = this.currentGame.id
            this.$axios.post(api.getMp3, { id: wordId })
                .then(res => {
                    var blobUrl = this.base64ToBlobUrl(res.data.result.base64Data)
                    this.myAudio = new Howl({
                        src: [blobUrl],
                        html5: true, // 强制使用HTML5 Audio
                        onend: () => {
                            this.iconPlay = 'el-icon-video-play'
                        }
                    })
                    this.myAudio.play()
                }).catch(() => {
                    this.iconPlay = 'el-icon-video-play'
                })
        },
        // 打乱数组顺序
        shuffleArray (array) {
            const newArray = [...array]
            for (let i = newArray.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [newArray[i], newArray[j]] = [newArray[j], newArray[i]]
            }
            return newArray
        },

        // 鼠标拖动开始
        handleDragStart (letter) {
            this.draggedLetter = letter
        },

        // 鼠标拖动结束
        handleDragEnd () {
            this.draggedLetter = null
            this.highlightedIndex = -1
        },

        // 鼠标拖动进入输入框
        handleDragEnter (index) {
            // 只在输入框为空时高亮
            if (!this.inputSlots[index]) {
                this.highlightedIndex = index
            }
        },

        // 鼠标拖动离开输入框
        handleDragLeave (index) {
            if (this.highlightedIndex === index) {
                this.highlightedIndex = -1
            }
        },

        // 鼠标放置
        handleDrop (index) {
            // 只允许放置到空的输入框
            if (!this.inputSlots[index] && this.draggedLetter) {
                this.placeLetter(index)
            }

            this.highlightedIndex = -1
        },

        // 触摸开始（字母）
        handleTouchStart (letter, e) {
            e.preventDefault()
            const touch = e.touches[0]
            this.draggedLetter = letter
            this.touchStartX = touch.clientX
            this.touchStartY = touch.clientY
            this.touchX = touch.clientX
            this.touchY = touch.clientY
        },

        // 触摸移动
        handleTouchMove (e) {
            if (!this.draggedLetter) return

            const touch = e.touches[0]
            const diffX = Math.abs(touch.clientX - this.touchStartX)
            const diffY = Math.abs(touch.clientY - this.touchStartY)

            // 超过阈值才认为是拖动
            if (diffX > this.touchThreshold || diffY > this.touchThreshold) {
                this.isTouchDragging = true
                this.touchX = touch.clientX
                this.touchY = touch.clientY

                // 检查当前触摸位置是否在某个输入框上
                this.checkTouchOverSlot(touch.clientX, touch.clientY)
            }
        },

        // 触摸结束
        handleTouchEnd () {
            if (this.isTouchDragging && this.highlightedIndex !== -1) {
                // 如果在输入框上结束触摸，则放置字母
                this.placeLetter(this.highlightedIndex)
            }

            // 重置触摸状态
            this.isTouchDragging = false
            this.draggedLetter = null
            this.highlightedIndex = -1
        },

        // 触摸输入框
        handleSlotTouchStart (index, e) {
            // 如果有选中的字母，直接放置
            if (this.selectedSlotIndex !== -1 && this.draggedLetter) {
                e.preventDefault()
                this.placeLetter(index)
                this.selectedSlotIndex = -1
                this.draggedLetter = null
            } else if (!this.inputSlots[index]) {
                // 否则选中这个槽位，等待选择字母
                this.selectedSlotIndex = index
            }
        },

        // 检查触摸位置是否在输入框上
        checkTouchOverSlot (x, y) {
            const slots = document.querySelectorAll('.input-slot')
            let overIndex = -1

            slots.forEach((slot, index) => {
                if (!this.inputSlots[index]) {
                    const rect = slot.getBoundingClientRect()
                    if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
                        overIndex = index
                    }
                }
            })

            this.highlightedIndex = overIndex
        },

        // 放置字母到指定位置
        placeLetter (index) {
            // 将字母放入输入框
            this.$set(this.inputSlots, index, this.draggedLetter)

            // 从字母数组中移除该字母
            const letterIndex = this.shuffledLetters.indexOf(this.draggedLetter)
            if (letterIndex !== -1) {
                this.shuffledLetters.splice(letterIndex, 1)
            }
            // 放置完成后清理拖动状态，防止重复使用同一个 draggedLetter
            this.draggedLetter = null
            this.selectedSlotIndex = -1
        },

        // 检查结果
        checkResult () {
            this.resultChecked = true

            // 规范化用户输入和目标单词：去掉空白并统一大小写，避免大小写/空白导致误判
            const userAnswer = (this.inputSlots.join('') || '').toString().replace(/\s+/g, '').toUpperCase()
            const expected = (this.targetWord || '').toString().replace(/\s+/g, '').toUpperCase()

            // console.log('用户答案:', userAnswer)
            // console.log('目标单词:', expected)

            // 比较是否与目标单词一致
            this.isCorrect = userAnswer === expected

            // 标记当前局结果（注意：currentGame 可能来自 props，若希望持久化应通过事件回传给父组件）
            this.currectCount++

            // 播放结果音效
            this.playResultAudio(this.isCorrect)
            this.allowNext = true
        },
        playResultAudio (isSuccess) {
            let audioData = isSuccess ? this.successAudio : this.failAudio
            if (audioData) {
                var blobUrl = this.base64ToBlobUrl(audioData)
                this.myAudio = new Howl({
                    src: [blobUrl],
                    html5: true, // 强制使用HTML5 Audio
                    onend: () => {
                        this.iconPlay = 'el-icon-video-play'
                    }
                })
                this.myAudio.play()
            }
        },
        // 将Base64转为Blob URL
        base64ToBlobUrl (base64) {
            const byteString = atob(base64)
            const ab = new ArrayBuffer(byteString.length)
            const ia = new Uint8Array(ab)

            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
            }

            const blob = new Blob([ab], { type: 'audio/mpeg' })
            return URL.createObjectURL(blob) // 返回Blob URL
        },
        // 重置游戏
        resetGame () {
            this.initGame()
        }
    },
    watch: {
        // 当父组件异步赋值 games 时，立即用第一项初始化当前局并重新初始化游戏
        games: {
            immediate: true,
            handler (newGames) {
                if (Array.isArray(newGames) && newGames.length > 0) {
                    // 复制一份到 currentGame，避免直接修改 props 内的数据
                    this.currentGame = Object.assign({}, newGames[0])
                    // 如果没有 index，保证 index 从 0 开始
                    if (this.currentGame.index === undefined) {
                        this.currentGame.index = 0
                    }
                    this.targetWord = (this.currentGame.word || '').toString().toUpperCase()
                    // 重新初始化游戏状态（字母、输入框、计时）
                    this.initGame()
                }
            }
        }
    }
}
</script>

<style scoped>
.game-container {
    max-width: 800px;
    margin: 1rem auto;
    padding: 1rem;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.game-header {
    text-align: center;
    margin-bottom: 1.2rem;
}

.hint-box {
    text-align: center;
    color: #3b82f6;
    font-weight: 500;
}

.letters-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}

.letter-item {
    width: 60px;
    height: 60px;
    background-color: #3b82f6;
    color: white;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    cursor: grab;
    transition: all 0.2s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    touch-action: none;
    /* 防止触摸时的默认行为 */
}

.letter-item:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.letter-item.dragging {
    opacity: 0.7;
    transform: scale(1.1) rotate(5deg);
    cursor: grabbing;
}

.input-container {
    display: flex;
    gap: 8px;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 10px;
}

.input-slot {
    width: 60px;
    height: 60px;
    border: 2px solid #d1d5db;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    transition: all 0.2s ease;
    touch-action: manipulation;
    /* 优化触摸操作 */
}

.input-slot:not(.filled):hover {
    background-color: rgba(59, 130, 246, 0.1);
}

.input-slot.highlighted {
    border-color: #3b82f6;
    background-color: rgba(59, 130, 246, 0.15);
}

.input-slot.filled {
    color: #3b82f6;
    border-color: #3b82f6;
}

.input-slot.correct {
    background-color: rgba(16, 185, 129, 0.1);
    border-color: #10b981;
    color: #10b981;
}

.input-slot.incorrect {
    background-color: rgba(239, 68, 68, 0.1);
    border-color: #ef4444;
    color: #ef4444;
}

.controls {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-top: 1.5rem;
    flex-wrap: wrap;
}

.check-btn,
.reset-btn {
    padding: 0.8rem 1.5rem;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    min-width: 130px;
    justify-content: center;
}

.check-btn {
    background-color: #10b981;
    color: white;
}

.check-btn:disabled {
    background-color: #a7f3d0;
    cursor: not-allowed;
}

.check-btn:not(:disabled):hover {
    background-color: #059669;
    transform: translateY(-2px);
}

.reset-btn {
    background-color: #6b7280;
    color: white;
}

.reset-btn:hover {
    background-color: #4b5563;
    transform: translateY(-2px);
}

.result-message {
    margin-top: 1.5rem;
    padding: 0.8rem;
    border-radius: 6px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    transition: all 0.3s ease;
}

.result-message.success {
    background-color: rgba(16, 185, 129, 0.1);
    color: #059669;
}

.result-message.error {
    background-color: rgba(239, 68, 68, 0.1);
    color: #dc2626;
}

.word-play {
    margin-left: 10px;
    color: #3bf6a2;
    cursor: pointer;
    font-size: 25px;
    border-radius: 5px;
}

/* 触摸模式下的跟随器 */
.touch-follower {
    position: fixed;
    pointer-events: none;
    width: 60px;
    height: 60px;
    background-color: #3b82f6;
    color: white;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transform: translate(-50%, -50%);
    opacity: 0.9;
    z-index: 1000;
}

.game-info-span {
    font-size: 18px;
    font-weight: bold;
    margin-left: 8px;
    text-align: center;
    color: #3b82f6;
}

.word-title {
    text-align: center;
    font-size: 15px;
    margin: 0px;
    padding: 5px 0px;
}

/* 响应式调整 */
@media (max-width: 600px) {
    .game-container {
        padding: 0.8rem;
        margin: 0.5rem;
    }

    .letter-item,
    .input-slot,
    .touch-follower {
        width: 50px;
        height: 50px;
        font-size: 22px;
    }

    .controls {
        gap: 0.8rem;
    }

    .check-btn,
    .reset-btn {
        padding: 0.7rem 1.2rem;
        font-size: 15px;
    }
}

@media (max-width: 400px) {

    .letter-item,
    .input-slot,
    .touch-follower {
        width: 45px;
        height: 45px;
        font-size: 20px;
    }

    .letters-container {
        gap: 8px;
    }

    .input-container {
        gap: 6px;
    }

    .sound-uppercase {
        text-align: center;
        margin: 10px auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/game/wordtemplete.vue